export default "__VITE_ASSET__yF8Ovi4S__"